import { render, staticRenderFns } from "./VehicleDetail.vue?vue&type=template&id=8c386ea8&scoped=true"
import script from "./VehicleDetail.vue?vue&type=script&lang=js"
export * from "./VehicleDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c386ea8",
  null
  
)

export default component.exports